import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h2",
    as: "p",
    css: css`
        margin: 0;
        @media print {
            font-size: 11px;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 20px !important;
                `,
                css`
                    font-size: 32px !important;
                `,
                null,
                null,
                null,
            ])}
    `,
};
